// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.euuadq0 {
  max-width: 100%;
  padding: 0;
}
@media screen and (min-width: 768px) {
  .euuadq0 {
    max-width: 540px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".euuadq0 {\n  max-width: 100%;\n  padding: 0;\n}\n@media screen and (min-width: 768px) {\n  .euuadq0 {\n    max-width: 540px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
